import { render } from "./corporation-list.vue?vue&type=template&id=383ee611&scoped=true"
import script from "./corporation-list.vue?vue&type=script&lang=js"
export * from "./corporation-list.vue?vue&type=script&lang=js"

import "./corporation-list.vue?vue&type=style&index=0&id=383ee611&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383ee611"]])

export default __exports__